// @ts-strict-ignore
import {apiClient} from 'common/util/api-client';
import {Metric, MetricsRequest, MetricsResponse, MetricsResultsMap} from 'app_api/projects/metrics/types';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {getProjectId} from 'common/report/util';
import {ToastType} from 'common/components/toast/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {reporter} from 'common/report/error-reporting';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint({metricId = null}: {metricId?: string} = {}): string {
  return appApiUrl(`metrics` + (metricId ? `/${metricId}` : ``), {projectId: getProjectId()});
}

export function showMetricsApiErrorToast(
  message: string = `Sorry, something went wrong. Please contact support if this problem persists.`,
) {
  addToast({
    message: () => message,
    type: ToastType.ERROR,
    timeout: null,
  });
}

export async function createMetric(metricsRequest: MetricsRequest): Promise<MetricsResultsMap> {
  try {
    return await apiClient.post<MetricsResultsMap>(buildEndpoint(), metricsRequest);
  } catch (error) {
    reporter.error(error, `createMetric error`, {metricsRequest});
    throw error;
  }
}

export async function updateMetric({
  metricId,
  metric,
}: {
  metricId: string;
  metric: Partial<Metric>;
}): Promise<MetricsResultsMap> {
  try {
    return await apiClient.patch<MetricsResultsMap>(buildEndpoint({metricId}), metric);
  } catch (error) {
    reporter.error(error, `updateMetric error`, {metricId, metric});
    throw error;
  }
}

export async function bulkUpdateMetrics(metrics: Array<Partial<MetricsRequest>>): Promise<MetricsResultsMap> {
  try {
    return await apiClient.patch<MetricsResultsMap>(buildEndpoint(), {metrics});
  } catch (error) {
    reporter.error(error, `bulkUpdateMetrics error`, {metrics});
    throw error;
  }
}

export async function bulkDeleteMetrics(metrics: Metric[]): Promise<MetricsResultsMap> {
  try {
    return await apiClient.delete<MetricsResultsMap>(buildEndpoint(), {
      body: JSON.stringify({metrics}),
    });
  } catch (error) {
    reporter.error(error, `bulkDeleteMetrics error`, {metrics});
    throw error;
  }
}

export const metricsClient: ApiResourceClient<TODO> = {
  index() {
    return apiClient.hydratedGet<MetricsResponse>(buildEndpoint());
  },

  get(metricId: string) {
    return apiClient.hydratedGet<MetricsResponse>(buildEndpoint({metricId}));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
